import React, { Children, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Banner from "../MSkillListingPage/assets/mskillBanner.svg";
import CourseAccordian from "./CourseAccordian";
import { useDispatch, useSelector } from "react-redux";
import {
  faCirclePause,
  faCirclePlay,
  faLock,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { LazyLoadImage } from "react-lazy-load-image-component";
import mixpanel, { disable } from "mixpanel-browser";
import {
  fetchPersonalisedCurationStatus,
  fetchPersonalisedRazorpayStatus,
  generatePersonalisedOrderID,
  getAllPersonalizeCourses,
  getCourseContent,
  getCourseMetaTags,
  getCurationStatus,
  getCustomCourse,
  getPersonalizeUserData,
  getUserCourseNames,
} from "../../redux/actions/personalize";
import { toast } from "react-toastify";
import { Dialog } from "@headlessui/react";
import { IKImage } from "imagekitio-react";
import Slider from "react-slick";
import useRazorpay from "react-razorpay";
import { RAZORPAY_KEY } from "../../config/api_config";
import { SET_USER_PERSONALISE_COURSE } from "../../redux/actions/types";
import LearningSection from "../MSkillListingPage/LearningSection";
import Constants from "../../common/constants";
import { Mixpanel } from "../../config/Mixpanel";

const CoursePage = () => {
  const { course } = useParams();
  const user_id = useSelector((store) => store?.profileDetails?.id);
  const navigate = useNavigate();
  const [metaTags, setMetaTags] = useState({
    title: "Some Title",
    description: "Some Description",
  });
  const [isVisible, setIsVisible] = useState(true);
  const [showCardAtBottom, setShowCardAtBottom] = useState(false);
  const dispatch = useDispatch();
  const email_id = useSelector((store) => store?.profileDetails?.email);
  const name = useSelector((store) => store?.profileDetails?.name);
  const first_name = useSelector((store) => store?.profileDetails?.first_name);
  const phone = useSelector((store) => store?.profileDetails?.["phone-number"]);
  const [openModal, setOpenModal] = useState(false);
  const [courseDetails, setCourseDetails] = useState({});
  const [isPersonaliseUser, setIsPersonaliseUser] = useState(false);
  const [userPersonaliseData, setUserPersonalizeData] = useState({});
  const [slicedOutcomes, setSlicedOutComes] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLocked, setIsLocked] = useState(false);
  const [isCurated, setIsCurated] = useState(false);
  const [buttonStates, setButtonStates] = useState(false);
  const Razorpay = useRazorpay();

  console.log("Thursday", isLocked, isCurated, buttonStates);
  const listenToScroll = () => {
    if (window.innerHeight + window.pageYOffset >= document.body.offsetHeight) {
      isVisible && setIsVisible(false);
    } else {
      setIsVisible(true);
    }
    // Get scrollY
    if (window.scrollY > 325) {
      setShowCardAtBottom(true);
    } else {
      setShowCardAtBottom(false);
    }
  };

  const [content, setContent] = useState([
    {
      skill: "Some mskill",
      lessons: [
        "Some Lesson",
        "Some Lesson",
        "Some Lesson",
        "Some Lesson",
        "Some Lesson",
      ],
    },
    {
      skill: "Some mskill",
      lessons: [
        "Some Lesson",
        "Some Lesson",
        "Some Lesson",
        "Some Lesson",
        "Some Lesson",
      ],
    },
    {
      skill: "Some mskill",
      lessons: [
        "Some Lesson",
        "Some Lesson",
        "Some Lesson",
        "Some Lesson",
        "Some Lesson",
      ],
    },
    {
      skill: "Some mskill",
      lessons: [
        "Some Lesson",
        "Some Lesson",
        "Some Lesson",
        "Some Lesson",
        "Some Lesson",
      ],
    },
    {
      skill: "Some mskill",
      lessons: [
        "Some Lesson",
        "Some Lesson",
        "Some Lesson",
        "Some Lesson",
        "Some Lesson",
      ],
    },
    {
      skill: "Some mskill",
      lessons: [
        "Some Lesson",
        "Some Lesson",
        "Some Lesson",
        "Some Lesson",
        "Some Lesson",
      ],
    },
    {
      skill: "Some mskill",
      lessons: [
        "Some Lesson",
        "Some Lesson",
        "Some Lesson",
        "Some Lesson",
        "Some Lesson",
      ],
    },
    {
      skill: "Some mskill",
      lessons: [
        "Some Lesson",
        "Some Lesson",
        "Some Lesson",
        "Some Lesson",
        "Some Lesson",
      ],
    },
    {
      skill: "Some mskill",
      lessons: [
        "Some Lesson",
        "Some Lesson",
        "Some Lesson",
        "Some Lesson",
        "Some Lesson",
      ],
    },
  ]);

  function getLessons() {
    let count = 0;
    for (let i = 0; i < content?.data?.length; i++) {
      count += content?.data[i]?.lessons?.length;
    }

    return count;
  }

  const features = [
    "Industry Recognised Certifications",
    "Practical Projects & Assessments",
    "Live Doubt Solving",
    "Interview Training & Feedback",
    "Lifetime Access",
  ];
  const outcomeSettings = {
    dots: false,
    slidesToShow: 1,
    rows: 1,
    speed: 300,
    cssEase: "linear",
    infinite: true,
    dots: true,
    arrows: false,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          infinite: false,
          dots: true,
          arrows: false,
          swipeToSlide: true,
        },
      },
    ],
  };

  useEffect(() => {
    window.addEventListener("scroll", listenToScroll);
    dispatch(
      getCourseMetaTags(
        course,
        (successObj) => {
          if (successObj?.status === "success")
            setMetaTags((prev) => ({
              ...prev,
              title: successObj?.data?.meta_data?.meta_title,
              description: successObj?.data?.meta_data?.meta_description,
            }));
          else toast.error(successObj?.message);
        },
        (errorObj) => toast.error(errorObj.message)
      )
    );

    dispatch(
      getCourseContent(
        course,
        (successObj) => {
          if (successObj?.status === "success") {
            setContent(successObj);
          } else toast.error(successObj?.message);
        },
        (errorObj) => toast.error(errorObj.message)
      )
    );
  }, []);

  useEffect(() => {
    dispatch(
      getPersonalizeUserData(
        email_id,
        (successObj) => {
          if (successObj?.Error?.length > 0) {
            //not personalize user
            console.log("thur 1");

            setIsPersonaliseUser(false);
            setIsLocked(true);
            setButtonStates(true);
          } else {
            setIsPersonaliseUser(true);
            //personalize user;
            console.log("thur 2");
            dispatch(
              getAllPersonalizeCourses(
                successObj?.uid,
                successObj?.access_token,
                (result) => {
                  dispatch({
                    type: SET_USER_PERSONALISE_COURSE,
                    payload: result,
                  });

                  const filterCourse = result?.filter(
                    (item) =>
                      item?.course_name?.toLocaleLowerCase() ===
                      course?.toLocaleLowerCase()
                  )?.[0];
                  console.log("thur", filterCourse);
                  if (
                    filterCourse?.is_locked === true &&
                    filterCourse?.is_under_curation === true
                  ) {
                    setIsLocked(false);
                    setIsCurated(false);
                    setButtonStates(true);
                  } else if (
                    filterCourse?.is_locked === true &&
                    filterCourse?.is_under_curation === false
                  ) {
                    setIsLocked(true);
                    setIsCurated(false);
                    setButtonStates(true);
                  } else if (
                    filterCourse?.is_locked === false &&
                    filterCourse?.is_under_curation === false
                  ) {
                    setIsLocked(false);
                    setIsCurated(true);
                    setButtonStates(true);
                  } else {
                    setIsLocked(true);
                    setIsCurated(false);
                    setButtonStates(true);
                  }
                },
                (err) => {
                  toast.error(err);
                }
              )
            );
          }
        },
        (errorObj) => {}
      )
    );
  }, []);

  useEffect(() => {
    dispatch(
      getCustomCourse(
        name,
        email_id,
        phone,
        course,
        (successObj) => {
          setCourseDetails(successObj);
          const subarrays = [];

          for (let i = 0; i < successObj?.outcome?.length; i += 3) {
            subarrays.push(successObj?.outcome?.slice(i, i + 2));
          }

          setSlicedOutComes(subarrays);
        },
        (errorObj) => {}
      )
    );
  }, []);

  const spinner = (color) => {
    return (
      <div
        className={`mr-1 h-4  w-4 animate-spin rounded-full border-2 border-${color} border-t-transparent`}
      ></div>
    );
  };

  const getOrderStatusSuccess = (response, succesObj) => {
    console.log(">>>successData<<<", response);
    dispatch(
      fetchPersonalisedRazorpayStatus(
        courseDetails?.uuid,
        response?.razorpay_payment_id,
        response?.razorpay_order_id,
        false,
        response?.razorpay_signature,
        {},
        "",
        (succesObj) => {
          setIsLoading(false);
          dispatch(
            fetchPersonalisedCurationStatus(
              name,
              courseDetails?.uuid,
              email_id,
              course,
              "",
              courseDetails?.is_curation,
              courseDetails?.["current_id"],
              "",
              () => {
                // setIsPaymentModalVisible(false);
                //successPaymentCallback(skillMetaData?.course_name);
                window.location.reload();
                setIsLoading(false);
                setTimeout(() => {
                  setIsLocked(false);
                  setIsCurated(false);
                }, 4000);
              },
              (errorObj) => {
                setIsLoading(false);
              }
            )
          );
        },
        (errorObj) => {
          setIsLoading(false);
        }
      )
    );
  };

  const getOrderStatusFailure = (errorData) => {
    console.log(errorData);
    dispatch(
      fetchPersonalisedRazorpayStatus(
        courseDetails?.uuid,
        errorData?.error?.metadata?.payment_id,
        errorData?.error?.metadata?.order_id,
        true,
        "",
        { ...errorData?.error },
        ""
      ),
      (succesObj) => {
        setIsLoading(false);
      },
      (errorObj) => {
        setIsLoading(false);
      }
    );
  };

  console.log("thursday 2", courseDetails);

  const onUnlockCourse = (callback) => {
    try {
      setIsLoading(true);
      dispatch(
        generatePersonalisedOrderID(
          courseDetails?.current_id,
          299,
          // PERSONALISED_COURSE_PRICING, // TODO: Uncomment this
          "Personalised Course",
          "",
          (successObj) => {
            // setUserPersonalizeData((prev) => ({
            //   ...prev,
            //   course_uid: successObj?.uid,
            // }));
            const options = {
              key: RAZORPAY_KEY,
              amount: `${299 * 100}`,
              currency: "INR",
              name: `Personalised ${course} Course`,
              description: "",
              image: "",
              order_id: successObj?.razorpay_order_id,
              modal: {
                ondismiss: function (response) {
                  console.log("dissmised");
                  console.log(response);
                  setIsLoading(false);
                  // getOrderStatusFailure(response)
                },
              },
              handler: (response) => {
                getOrderStatusSuccess(response, successObj);
                callback();
              },
              prefill: {
                name: first_name,
                email: email_id,
                contact: phone,
              },
              // notes: {
              //     address: "Razorpay Corporate Office"
              // },
              theme: {
                color: "#26CBA7",
              },
            };

            const razorpayInitializor = new Razorpay(options);

            razorpayInitializor.on("payment.failed", function (response) {
              getOrderStatusFailure(response);
              callback();
            });

            razorpayInitializor.open();
            setOpenModal(false);
          }
        )
      );
    } catch (error) {
      console.log(">>>error onUnlockCourse<<<", error);
    }
  };

  return (
    <div className="bg-white">
      <div
        className="bg-white bg-cover bg-center bg-no-repeat pt-8 pb-4"
        style={{ backgroundImage: `url('${Banner}')` }}
      >
        <div className="container mx-auto flex w-full flex-col px-2 md:flex-row md:px-6 ">
          <div className="w-full text-white md:mr-12 md:w-2/3">
            <h1 className="text-2xl font-bold md:text-4xl">
              {metaTags?.["title"]}
            </h1>
            <h2 className="mt-4 text-base md:text-lg">
              {metaTags?.["description"]}
            </h2>
          </div>
          <div
            className={` z-[9] mx-auto w-[100%]  border-2 shadow-lg lg:hidden ${
              showCardAtBottom ? "fixed   bottom-0 left-0 right-0 " : " mt-2"
            }   rounded  p-1 `}
            style={{ "z-index": "9 !important", background: "white" }}
          >
            <div className="  flex h-full  justify-between  overflow-hidden">
              <div className=" basis-[25%]  self-center overflow-clip  border-slate-300 pr-1 align-middle">
                <LazyLoadImage
                  src={content?.thumbnail_url?.replace(
                    "default",
                    "maxresdefault"
                  )}
                  width={"100%"}
                  alt=""
                  effect="blur"
                  className="mt-1 w-full rounded"
                  style={{
                    display: "block",
                    objectPosition: "center",
                    objectFit: "cover",
                  }}
                  placeholderSrc={"/img/skill-small.webp"}
                />
              </div>

              <div className="flex basis-[40%] flex-col justify-evenly px-1">
                <h3 className="text-[10px]  font-bold text-[#0E0E0E] line-clamp-2">
                  {metaTags?.title}
                </h3>
              </div>

              <div className=" mx-1 flex basis-[45%] flex-col items-center justify-around overflow-hidden bg-white ">
                <button
                  className={`mr-1 w-full rounded ${
                    isLocked === false && isCurated === false && "opacity-50"
                  } bg-[#FDBF48] py-2 px-1 text-center text-[10px] font-semibold shadow-lg hover:bg-[#eeb242] focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 focus:ring-offset-orange-200 disabled:bg-slate-200 md:text-base`}
                  onClick={() => {
                    Mixpanel.track(Constants.Mixpanel.COURSE_PAGE_INFO_CARD_CLICKED, {
                      distinct_id: email_id
                  });
                    if (user_id) {
                      if (isLocked === true) {
                        setOpenModal(true);
                      } else {
                        if (isCurated) {
                          window.location.href = `https://personalise.learntube.ai/welcome?email=${email_id}&skill_name=${encodeURIComponent(course)}&utm_source=popular-course&utm_medium=info-card`;
                        }
                      }
                    } else navigate(`/login?course=${course}`);
                  }}
                >
                  {!user_id
                    ? "Start Learning"
                    : buttonStates &&
                      (isLocked ? (
                        <div className="flex items-center justify-center">
                          <FontAwesomeIcon icon={faLock} className="mr-1" />
                          Unlock
                        </div>
                      ) : isCurated ? (
                        <div>Start Learning</div>
                      ) : (
                        <div className="flex items-center justify-center ">
                          {spinner("black")} <span className="ml-1">Creating Your Course</span>
                        </div>
                      ))}
                </button>
                {buttonStates && isLocked === false && isCurated === false && (
                  <div className="text-[10px]">Course is under curation</div>
                )}
              </div>
            </div>
            {!showCardAtBottom && (
              <div className="mt-2">
                <ul className="flex justify-evenly text-[8px] font-bold">
                  <li>&#8226; {getLessons()} Lessons</li>
                  <li>&#8226; {content?.data?.length} Micro-Skills</li>
                  <li>&#8226; Certificate of Achievement</li>
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="bg-white flex w-full flex-col space-y-2 py-10 px-4 md:px-6 lg:w-2/3">
        {content?.data?.map((skill, index) => (
          <CourseAccordian
            title={skill?.mskill_name}
            id={index}
            isLocked={isLocked}
            isCurated={isCurated}
            buttonStates={buttonStates}
          >
            <ul>
              {skill["lessons"].map((lesson, idx) => (
                <div
                  onClick={(e) => {
                    Mixpanel.track(Constants.Mixpanel.COURSE_PAGE_LESSON_LIST_CLICKED, {
                      distinct_id: email_id
                  });
      
                    if (user_id) {
                      if (isLocked === true) {
                        setOpenModal(true);
                      } else {
                        if (isCurated) {
                          window.location.href = `https://personalise.learntube.ai/welcome?email=${email_id}&skill_name=${encodeURIComponent(course)}&utm_source=popular-course&utm_medium=lesson-list`;
                        }
                      }
                    } else navigate(`/login?course=${course}`);
                  }}
                  key={idx}
                >
                  <li className="flex cursor-pointer items-center justify-between px-3 py-1 text-xs hover:bg-neutral-100 md:text-base">
                    <h3 className={"w-full text-[#636363]"}>
                      <FontAwesomeIcon
                        className={"mr-3 text-[#636363]"}
                        icon={faCirclePlay}
                      />
                      {lesson}
                    </h3>
                  </li>
                </div>
              ))}
            </ul>
          </CourseAccordian>
        ))}
        <div className="bg-white">
          <LearningSection data={courseDetails?.outcome} />
        </div>
      </div>
      {/* <div className="mx-auto leading-tight flex w-full lg:w-2/3 flex-col justify-start items-start px-4 mb-10 md:px-6 ">
        
      </div> */}
      {isVisible && (
        <div
          className="bg-white md:mb-15 z-1 ml-auto mt-2 mr-5  hidden h-[65%] w-full cursor-pointer overflow-y-auto md:fixed md:top-[18%] md:right-10 md:mt-0  md:w-1/4 lg:block"
          onClick={(e) => {
            Mixpanel.track(Constants.Mixpanel.COURSE_PAGE_INFO_CARD_CLICKED, {
              distinct_id: email_id
          });
            if (user_id) {
              if (isLocked === true) {
                setOpenModal(true);
              } else {
                if (isCurated) {
                  window.location.href = `https://personalise.learntube.ai/welcome?email=${email_id}&skill_name=${encodeURIComponent(course)}&utm_source=popular-course&utm_medium=info-card`;
                }
              }
            } else navigate(`/login?course=${course}`);
          }}
          style={{ marginTop: "4%" }}
        >
          <div className="flex h-full flex-col  overflow-hidden rounded-xl border-[1px]  border-slate-300 bg-white">
            <div className="flex justify-center overflow-clip border-b-2 border-slate-300 align-middle">
              <img
                className="w-full object-cover"
                src={content?.thumbnail_url?.replace(
                  "default",
                  "maxresdefault"
                )}
                width={"100%"}
                height={100}
                alt="skill"
              />
            </div>
            <div className="overflow-y-auto bg-white p-3">
              <h2 className="truncate text-xl font-semibold text-gray-900">
                {metaTags?.title}
              </h2>
              <button
                className={`my-1 mr-1 w-full ${
                    isLocked === false && isCurated === false && "opacity-50"
                  } rounded bg-[#FDBF48] py-2 px-8 text-center text-[11px] font-semibold shadow-lg hover:bg-[#eeb242] focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 focus:ring-offset-orange-200 disabled:bg-slate-200 md:text-base`}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  Mixpanel.track(Constants.Mixpanel.COURSE_PAGE_INFO_CARD_CLICKED, {
                    distinct_id: email_id
                });
                  if (user_id) {
                    if (isLocked === true) {
                      setOpenModal(true);
                    } else {
                      if (isCurated) {
                        window.location.href = `https://personalise.learntube.ai/welcome?email=${email_id}&skill_name=${encodeURIComponent(course)}&utm_source=popular-course&utm_medium=info-card`;
                      }
                    }
                  } else navigate(`/login?course=${course}`);
                }}
              >
                {!user_id
                  ? "Start Learning"
                  : buttonStates &&
                    (isLocked ? (
                      <div className="flex items-center justify-center">
                        <FontAwesomeIcon icon={faLock} className="mr-1" />
                        Unlock
                      </div>
                    ) : isCurated ? (
                      <div>Start Learning</div>
                    ) : (
                      <div className="flex items-center justify-center">
                        {spinner("black")} <span className="ml-1">Creating Your Course</span>
                      </div>
                    ))}
              </button>
              {buttonStates && isLocked == false && isCurated == false && (
                <div className="text-center text-[12px]">
                  Course is under curation, It can take upto 15-20 minutes
                </div>
              )}
              <div className="w-full">
                <h2 className="py-2 text-lg font-bold">What You Get:</h2>
                <ul className="grid w-[90%] grid-cols-2 gap-0 space-y-1 px-1 text-sm">
                  <li>
                    <span>&#8226; {getLessons()} Lessons</span>
                  </li>
                  <li>
                    <span>&#8226; {content?.data?.length} Micro-Skills</span>
                  </li>
                  <li>
                    <span>&#8226; {content?.["enrolled_count"]} Students</span>
                  </li>
                  <li>
                    <span className="whitespace-nowrap">
                      &#8226; Certificate of Achievement
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}

      {openModal && (
        <Dialog
          open={openModal}
          onClose={() => setOpenModal(false)}
          as="div"
          style={{ zIndex: "9999999999" }}
          className="fixed inset-0 z-10 my-auto flex flex-col items-center justify-center  md:justify-start"
        >
          <Dialog.Overlay className="fixed inset-0 z-10 bg-black opacity-70" />
          <Dialog.Title />
          <Dialog.Description />
          <div className="relative z-10 my-auto flex w-[95%] flex-col items-center justify-start rounded-2xl bg-white py-2 px-2 leading-tight shadow-2xl md:w-[30%] md:px-3 ">
            <img
              urlEndpoint="https://assets.learntube.ai/files/"
              src="https://assets.learntube.ai/files/Learntube/Group%2010096.svg?updatedAt=1705591577259"
              className="h-[120px] w-[232px]"
              transformation={[
                {
                  height: "50",
                  width: "50",
                },
              ]}
            />
            <div className="mt-2 text-center text-[24px]">
              {first_name},{" "}
              <span className="font-semibold text-[#3BA3DD]">
                Unlock Your Personalised Course
              </span>{" "}
              On {course}
            </div>
            <div className="mt-4 flex w-full items-center justify-start">
              <img
                urlEndpoint="https://assets.learntube.ai/files/"
                src="https://assets.learntube.ai/files/Learntube/Group%2010097.svg?updatedAt=1705730765771"
                className="mr-2 h-[24px] w-[24px]"
                transformation={[
                  {
                    height: "50",
                    width: "50",
                  },
                ]}
              />
              <div className="text-[16px] font-semibold md:text-[20px] ">
                What Will You Learn?
              </div>
            </div>
            <div className="w-full">
              <Slider {...outcomeSettings}>
                {slicedOutcomes?.length > 0 &&
                  slicedOutcomes?.map((item, index) => (
                    <div className="w-full">
                      <div className="grid w-[99%] grid-cols-1 grid-rows-2 ">
                        {item?.map((text, index) => (
                          <div className="mt-2 flex h-[60px] items-start justify-start overflow-auto  rounded-lg bg-[#D7FFD1] p-2 md:h-[60px]">
                            <img
                              urlEndpoint="https://assets.learntube.ai/files/"
                              src="https://assets.learntube.ai/files/Learntube/Group%2010098.svg?updatedAt=1705731539324"
                              className="mr-4"
                              transformation={[
                                {
                                  height: "50",
                                  width: "50",
                                },
                              ]}
                            />
                            <span className="text-start w-full text-[14px]  md:text-[16px]">
                              {text?.slice(2)}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
              </Slider>
            </div>

            <div className="mt-8 flex w-full items-center justify-start">
              <img
                urlEndpoint="https://assets.learntube.ai/files/"
                src="https://assets.learntube.ai/files/Learntube/Features.svg?updatedAt=1705730765841"
                className="mr-2 h-[24px] w-[24px]"
                transformation={[
                  {
                    height: "50",
                    width: "50",
                  },
                ]}
              />
              <div className="text-[16px] font-semibold md:text-[20px] ">
                Packed With Exclusive Features
              </div>
            </div>

            <div className="mt-2 flex h-[130px] w-full flex-col items-center justify-start overflow-auto">
              {features?.map((item, index) => (
                <div className="my-1 flex w-full items-center justify-start rounded-xl bg-[#E5FCFF] p-2">
                  <img
                    urlEndpoint="https://assets.learntube.ai/files/"
                    src="https://assets.learntube.ai/files/Learntube/Group%2010099.svg?updatedAt=1705733157919"
                    className="mr-2"
                    transformation={[
                      {
                        height: "50",
                        width: "50",
                      },
                    ]}
                  />
                  <div className="text-[14px] font-normal md:text-[16px]">
                    {item}
                  </div>
                </div>
              ))}
            </div>
            <div className="mt-6 flex w-[95%] flex-col items-center justify-center">
              <button
                className="flex w-full items-center justify-center rounded-lg bg-[#13B284] p-2 text-[16px] font-semibold text-white"
                onClick={(e) => onUnlockCourse()}
              >
                {isLoading ? spinner("white") : "Unlock Personalise Course"}
              </button>
              <div className="mt-1 flex items-center justify-center text-[12px] font-medium">
                <div className="mr-1">Buy @ ₹299</div>
                <div className="text-[#E06064] line-through">₹999</div>
              </div>
            </div>
          </div>
        </Dialog>
      )}
    </div>
  );
};

export default CoursePage;
